const DEFAULT_CARD_HEIGHT_PERCENTAGE = 50;
const OPEN_CARD_HEIGHT_PERCENTAGE = 80;
const MINIMIZED_CARD_HEIGHT_PERCENTAGE = 16;

enum CardPosition {
  OPEN = 'open',
  COLLAPSED = 'collapsed',
  HIDDEN = 'hidden',
  MINIMIZED = 'minimized',
}

export {
  DEFAULT_CARD_HEIGHT_PERCENTAGE,
  OPEN_CARD_HEIGHT_PERCENTAGE,
  MINIMIZED_CARD_HEIGHT_PERCENTAGE,
  CardPosition,
};
